<template>
  <div :class="$style.container">
    <slot />
  </div>
</template>

<style lang="scss" module>
.container {
  margin-top: 30px;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 20px;
  align-items: center;

  &::before,
  &::after {
    content: '';
    display: block;
    background: rgba(#000, 0.1);
    height: 1px;
  }
}
</style>
